<template>

<div @click="checkInputdata">

<div class="grid" :id="'input_columns_wrap_'+data.id">

<!-- read_only_state -->
<template v-if="data.read_only_state">
<div class="col-12 md:col-3">
<h4 class="text-primary font-bold m-1 p-0">{{$store.state.languages.lang_phrases.ulke}}</h4>
<p class="text-primary p-0 m-1">{{selectedcountry}}</p>
</div>
<div class="col-12 md:col-3">
<h4 class="text-primary font-bold m-1 p-0">{{$store.state.languages.lang_phrases.sehir}}</h4>
<p class="text-primary p-0 m-1">{{selectedcity}}</p>
</div>
<template v-if="data.is_postalcode_required">
<div class="col-12 md:col-3">
<h4 class="text-primary font-bold m-1 p-0">{{$store.state.languages.lang_phrases.posta_kodu}}</h4>
<p class="text-primary p-0 m-1">{{inputdata.postalcode}}</p>
</div>
<div class="col-12 md:col-2">
<h4 class="text-primary font-bold m-1 p-0">{{$store.state.languages.lang_phrases.adres}}</h4>
<p class="text-primary p-0 m-1">{{inputdata.address}}</p>
</div>
<div class="col-12 md:col-1">
<span class="material-icons md-22 md:ml-3 text-primary pt-4"
v-if="inputdata.address"
v-tooltip.bottom="{ value: location_text, disabled: false,class: 'custom-top-tooltip' }">
pin_drop
</span>  
</div>

</template>
<template v-else>
<div class="col-12 md:col-5">
<h4 class="text-primary font-bold m-1 p-0">{{$store.state.languages.lang_phrases.adres}}</h4>
<p class="text-primary p-0 m-1">{{inputdata.address}}</p>
</div> 
<div class="col-12 md:col-1">
<span class="material-icons md-26 md:ml-3 text-primary"
v-if="inputdata.address"
v-tooltip.bottom="{ value: location_text, disabled: false,class: 'custom-top-tooltip' }">
pin_drop
</span>  
</div>
</template>
</template>
<!-- read_only_state -->

<!-- editing -->
<template v-if="!data.read_only_state">
<div class="col-12 md:col-3">
<Dropdown v-model="inputdata.country_id" 
:options="countries" 
optionLabel="name" 
optionValue="id" 
class="w-full linebreak_dropdown p-inputtext-sm  mb-0 mt-2"   
@change="countrySelected" 
:filter="true" 
:disabled="dropdownNulled" 
:showClear="true" 
:loading="loading_countries"
:placeholder="$store.state.languages.lang_phrases.ulke_secin"
panelClass="linebreak_dropdown">
</Dropdown>
</div>

<div class="col-12 md:col-3">
<Dropdown v-model="inputdata.city_id" 
v-if="inputdata.country_id"
:options="cities" 
optionLabel="name" 
optionValue="id" 
class="w-full linebreak_dropdown p-inputtext-sm  mb-0 mt-2"   
@change="citySelected" 
:filter="true" 
:disabled="dropdownNulled" 
:showClear="true" 
:loading="loading_cities"
:virtualScrollerOptions="{ itemSize: 38 }"
:placeholder="$store.state.languages.lang_phrases.sehir_secin"
panelClass="linebreak_dropdown">
</Dropdown>
</div>

<template v-if="data.is_postalcode_required">
<div class="col-12 md:col-3">
<InputText   
v-model="inputdata.postalcode"  
class="w-full p-inputtext-sm mb-0 mt-2"  
:disabled="dropdownNulled"
v-if="inputdata.country_id && inputdata.city_id"
:placeholder="$store.state.languages.lang_phrases.posta_kodu"
@change="postalcodeEntered" 
/>
</div>

<div class="col-12 md:col-3">
<div class="grid-nogutter flex justify-content-start flex-wrap">

<div class="col">
<InputText   
v-model="inputdata.address"  
class="w-full p-inputtext-sm mb-0 mt-2"  
:disabled="dropdownNulled"
v-if="inputdata.country_id && inputdata.city_id"
v-on:keyup.enter="checkAddress"  
v-click-away="checkAddress"
@input="addressChanged"
:placeholder="$store.state.languages.lang_phrases.adres"
/>
</div>

<div class="col-fixed" style="width:40px">
<Button type="button"  
icon="pi pi-map-marker" 
@click="showMapDialog" 
v-if="inputdata.address"
class="p-button-primary p-button-outlined p-button-sm ml-2 mt-2"   />
</div>

</div>
</div>
</template>

<template v-else>
<div class="col-12 md:col-6" v-if="inputdata.city_id && inputdata.country_id">

<div class="grid-nogutter flex justify-content-start flex-wrap">

<div class="col">
<InputText   
v-model="inputdata.address"  
class="w-full p-inputtext-sm mb-0 mt-2"  
:disabled="dropdownNulled"
v-if="inputdata.country_id && inputdata.city_id"
v-on:keyup.enter="checkAddress"  
v-click-away="checkAddress"
@input="addressChanged"
:placeholder="$store.state.languages.lang_phrases.adres"
/>
</div>

<div class="col-fixed" style="width:40px">
<Button type="button"  
icon="pi pi-map-marker" 
@click="showMapDialog" 
v-if="inputdata.address"
class="p-button-primary p-button-outlined p-button-sm ml-2 mt-2"   />
</div>

</div>


</div>

</template> 
</template>
<!-- editing -->







</div>





<!-- dialog -->
<Dialog :header="$store.state.languages.lang_phrases.adres" 
v-model:visible="show_dialog" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '75vw'}"
:modal="true"
>
<template v-if="loading_map">
<FrameOverlay></FrameOverlay>
</template>



<template v-if="!loading_map">

<Listbox 
v-model="selected_location" 
:options="geocodes" 
@change="locationSelected"
optionLabel="formatted_address"
class="w-full mb-3" />

<GoogleMap
:api-key="apikey"
mapId="DEMO_MAP_ID"
style="width: 100%; height: 350px;margin-bottom: 30px;"
:center="center"
:zoom="8"
>
<AdvancedMarker 
v-for="geocode in geocodes"
:options="{position:geocode.geometry.location}" 
:pin-options="pinOptions"
/>
</GoogleMap>

</template>

<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideMapDialog" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>

<Button 
v-if="selected_location"
:label="$store.state.languages.lang_phrases.kaydet" 
icon="pi pi-check" 
@click="submitLocation" 
class=" p-button-primary p-button-outlined  p-button-sm" 
:loading="$store.state.ui.submitting"/>

</template>


</Dialog>

<!-- dialog -->
</div>

</template>

<script>
import { GoogleMap, AdvancedMarker } from 'vue3-google-map'
export default {

  name: 'LocationType',
  props:["data"],
  components:{GoogleMap,AdvancedMarker},
  data () {
    return {
    	inputdata:{
        country_id:null,
        city_id:null,
        address:null,
        latitude:null,
        longitude:null,
        postalcode:null,
      },
    	intervalobj:null,
      countries:[],
      cities:[],
      loading_countries:false,
      loading_cities:false,
      show_dialog:false,
      loading_map:true,
      apikey:process.env.VUE_APP_GMP_KEY,
      geocodes:[],
      center:null,
      selected_location:null,
    }
  },
  async mounted()
  {
  	 this.resolveInputdata()
  	
  },
  computed:{
    location_text()
    {
      if(this.inputdata.address && this.inputdata.longitude && this.inputdata.latitude)
      {
        return this.$store.state.languages.lang_phrases.enlem+": "+this.inputdata.latitude+" "+this.$store.state.languages.lang_phrases.boylam +": "+this.inputdata.longitude
      }
      return null
    },
    selectedcountry()
    {
      if(this.inputdata.country_id)
      {
        let country = this.countries.find(item=>item.id == this.inputdata.country_id)
        if(country)
        {
          return this.getTheTranslation(country,"translation")
        }
        return "-"
      }
      return "-"
    },
    selectedcity()
    {
      if(this.inputdata.city_id)
      {
        let city = this.cities.find(item=>item.id == this.inputdata.city_id)
        if(city)
        {
          return this.getTheTranslation(city,"translation")
        }
        return "-"
      }
      return "-"
    },
    pinOptions()
    {
      return { background: '#352f8d',borderColor:'#352f8d',glyphColor:"#ffffff" }
    },
    preflang_id()
    {
      return this.$store.state.auth.user.preflang_id
    },
    propdata()
    {
      if(this.data.submissions.length>0)
      {
        let propdata = this.data.submissions[0].submission_text

        return propdata
      }
    },
    dropdownNulled()
    {
      if(this.data.submissions.length && this.data.submissions[0].is_nulled)
      {
        return true
      }
      else
      {
        if(this.$store.state.ui.submitting)
        {
          return true
        }
        return false
      }
      
    },
  },
  watch:{
    preflang_id()
    {
      console.log("watch")
      this.getCountries()
    },
    propdata(newval)
    {
      this.resolveInputdata()
    },
    /*
    data()
    {
      if(this.data.submissions.length>0)
      {
        this.inputdata = this.data.submissions[0].submission_option
      }
      else
      {
        this.inputdata = null
      }
    },
    */
    show_dialog()
    {
      if(!this.show_dialog)
      {
        //this.loading_map = true     
      }
    },
  },
  methods: {
    async resolveInputdata(text)
    {
      if(this.data.submissions.length>0)
      {
        if(this.data.submissions[0].submission_option)
        {
          this.inputdata.country_id = this.data.submissions[0].submission_option
          await this.getCountries()          
          if(this.data.submissions[0].submission_text || this.data.submissions[0].submission_text!=="")
          {
            this.inputdata = JSON.parse(this.data.submissions[0].submission_text)
            await this.getCities()
          }
        }
      }
      else
      {
        //this.inputdata = null
        await this.getCountries()
      }
    },
    checkSubmission()
    {
      if(this.inputdata.country_id && this.inputdata.city_id && this.inputdata.address && this.inputdata.latitude && this.inputdata.longitude)
      {
          if(this.data.is_postalcode_required && this.inputdata.postalcode)
          {
            this.submitField()
          }
      }
    },
    submitField()
    {
      let formdata = new FormData()
      formdata.append("text",JSON.stringify(this.inputdata))
      formdata.append("type","location")
      formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)      
      this.submitInputFieldSubmission(formdata,this.data.id)
    },
    checkInputdata()
    {
      console.log("checkInputdata")
      console.log(this.inputdata)
    },
    submitLocation()
    {
      console.log(this.selected_location)
      this.inputdata.latitude = this.selected_location.geometry.location.lat
      this.inputdata.longitude = this.selected_location.geometry.location.lng
      this.hideMapDialog()
      this.submitField()
    },
    locationSelected()
    {
      console.log(this.selected_location)
      if(this.selected_location)
      {
        this.center = this.selected_location.geometry.location        
      }
      

    },
    addressChanged()
    {
      console.log("addressChanged")
      this.inputdata.latitude = null
      this.inputdata.longitude = null
      if(this.inputdata.address == "" || !this.inputdata.address)
      {
        this.submitField()
      }
    },
    checkAddress(e)
    {      
      console.log("checkAddress")
      console.log(this.inputdata)
      if(this.inputdata.address && !this.show_dialog)
      {
        console.log("address")
        if(!this.inputdata.latitude || !this.inputdata.longitude)
        {
          console.log(this.inputdata.latitude)      
          console.log(this.inputdata.longitude)
          console.log("showMapDialog")
          this.showMapDialog()
        }
      }
    },
    hideMapDialog()
    {      
      
      setTimeout(()=>{
        this.show_dialog = false
      })
    },
    async showMapDialog()
    {
      this.show_dialog = true
      this.loading_map = true
      let string = this.inputdata.address.replaceAll(" ","+")
      let url = "https://maps.googleapis.com/maps/api/geocode/json?address="+string+"&key="+this.apikey
      let geocode = await fetch(url) 
      geocode = await geocode.json();
      this.geocodes = geocode.results
      if(this.geocodes.length)
      {
        this.center = this.geocodes[0].geometry.location
        if(this.geocodes.length===1)
        { 
          this.selected_location = this.geocodes[0]
        }
      }
      else
      {

      }
      this.loading_map = false

    },
    citySelected()
    {
      this.submitField()
    },
    postalcodeEntered()
    {
      this.submitField()
    },
    countrySelected()
    {
      this.submitField()
      this.getCities()
    },
    renameCountries()
    {
      console.log("renameCountries")
      let list = []
      for(let item of this.raw_countries)
      {
        let obj = {
          name:this.getTheTranslation(item,"translation"),
          id:item.id
        }
        list.push(obj)
      }

      list.sort((a, b) =>{
        return a.name.localeCompare(b.name)
      });
      this.countries = list
    },
    async getCountries()
    {
      console.log("getCountries")
      if(!this.countries.length)
      {
        this.loading_countries = true
        this.raw_countries = await this.generalApiGet("countries") 
        this.loading_countries = false
      }
      this.renameCountries()      
    },
    async getCities()
    {      
      this.loading_cities = true
      this.cities = await this.generalApiGetWithoutLoader("cities/"+this.inputdata.country_id)  
      this.loading_cities = false          
    },
  	fieldChanged()
  	{
  		clearInterval(this.intervalobj);
  		this.intervalobj = setInterval(()=>{
  			this.submitInputData()
  		},1000)
  	},
  	submitInputData(input)
  	{
  		//clearInterval(this.intervalobj);
      if(!this.data.read_only_state)
      {
        this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
        this.inputdata = input
        let formdata = new FormData()
        formdata.append("option",input)
        formdata.append("type","boolean")
        formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)

        //return false
        this.submitInputFieldSubmission(formdata,this.data.id)
      }
      
  	},
  }
};
</script>

<style lang="css" scoped>
</style>